import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { SnackBarStoreAction } from "Store/SnackBar";
import BackdropComponent from "../../Spinner/Spinner";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  InputLabel,
  MenuItem,
  FormControl,
  Select,
  TextField,
  InputAdornment,
  IconButton,
  Typography,
} from "@mui/material";

import LastUpdateTooltip from "../Helpers/LastUpdateTooltip";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import NotInterestedIcon from "@mui/icons-material/NotInterested";

import {
  techEquipSolution,
  getCurrentEquipmentSetup,
  getRefreshedTrackingStatus,
  getOverrideEmployeesData,
  saveBulkEditEmployeeData,
} from "services/userServices";
import { useNavigate } from "react-router-dom";
import classes from "./EmployeeData.module.css";
import SnackBar from "components/SnackBar/SnackBar";
import { useTranslation } from "react-i18next";
import { bulkEditStoreAction } from "../../../Store/BulkEdit";
import PropTypes from "prop-types";
import PowerSharpIcon from "@mui/icons-material/PowerSharp";
import Tooltip from "@mui/material/Tooltip";
import Grid from "@mui/material/Grid";
import applicationUsageLog from "../../../utils/applicationUsagesLog";
import { Box, Button } from "@mui/material";
import { styled } from "@mui/material/styles";
import LaunchOutlinedIcon from "@mui/icons-material/LaunchOutlined";
import CachedOutlinedIcon from "@mui/icons-material/CachedOutlined";

const getFilteredData = (data, property, value) =>
  data.filter((itm) => itm[property] === value);

const ITPickupDropDown = () => {
  return [
    "Picked Up",
    "Partially Received",
    "Received Bio-Hazard",
    "Received Damaged",
    "Received Not Functional",
  ];
};

const EquipmentIssueDropDown = () => {
  return [
    "Damaged – Cable/Adapter",
    "Damaged – PC",
    "Damaged – Peripheral",
    "Defective – SSD",
    "Delayed – Ticket/Provisioning",
    "Equipment – Not Shipped",
    "Equipment – Shipped to Revert",
    "Address – Incomplete or Incorrect",
    "Address – Incorrect",
    "Incorrect – Cable/Adapter",
    "Incorrect – Peripheral",
    "Incorrect – Ticket/Provisioning",
    "Lost/Delayed – Full Shipment",
    "Lost/Delayed – Partial Shipment",
    "Missing – Cable/Adapter",
    "Missing – Peripheral",
    "Missing – Tracking Number",
    "Non-Functional – PC",
    "Non-Functional – Peripheral",
  ];
};

const CustomButton = styled(Button)(() => ({
  fontFamily: "Urbanist, Verdana, Arial, sans-serif",
  fontSize: "12px",
  letterSpacing: "0.10em",
  borderRadius: "8px",
  fontWeight: "600",
  textTransform: "none",
  color: "white",
  marginTop: "-10px",
  backgroundColor: "#3299FF",
  "&:hover": {
    backgroundColor: "#2878CC",
  },
}));
const CustomOutlinedButton = styled(Button)(() => ({
  fontFamily: "Urbanist, Verdana, Arial, sans-serif",
  fontSize: "12px",
  letterSpacing: "0.10em",
  borderRadius: "8px",
  fontWeight: "600",
  textTransform: "none",
  borderColor: "#3299FF",
  color: "#3299FF",
  marginTop: "-10px",
  "&:hover": {
    borderColor: "#3299FF",
    backgroundColor: "#E0F2FF",
  },
}));

const CustomUploadhButton = styled(Button)(() => ({
  fontFamily: "Urbanist, Verdana, Arial, sans-serif",
  fontSize: "12px",
  letterSpacing: "0.10em",
  fontWeight: "600",
  textTransform: "none",
  color: "#3299FF",
  height: "auto",
  borderRadius: "30px",
  width: "140px",
  backgroundColor: "white",
  opacity: 1,
  marginTop: "10px",
  whiteSpace: "normal",
  "&:hover": {
    borderColor: "#3299FF",
    backgroundColor: "#E0F2FF",
    opacity: 0.9,
  },
}));
const CustomRefreshButton = styled(Button)(() => ({
  fontFamily: "Urbanist, Verdana, Arial, sans-serif",
  fontSize: "12px",
  letterSpacing: "0.10em",
  fontWeight: "600",
  textTransform: "none",
  color: "white",
  height: "auto",
  borderRadius: "30px",
  width: "150px",
  backgroundColor: "#3299FF",
  opacity: 1,
  marginTop: "10px",
  whiteSpace: "normal",
  "&:hover": {
    backgroundColor: "#2878CC",
    opacity: 0.9,
  },
}));
const EmployeeData = (props) => {
  const { t } = useTranslation(["EmployeeData"]);
  const [itPickupDropDownValue, setITPickupDropDownValue] = useState("");
  const [equipmentIssueDropDownValue, setEquipmentIssueDropDownValue] =
    useState("");
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [agentComments, setAgentComments] = useState("");
  const [techSolData, setTechSolData] = useState([]);
  const [techSolStatus, setTechSolStatus] = useState("");
  const [currentEquipStatus, setCurrentEquipStatus] = useState("");
  const [employeeData, setEmployeeData] = useState([]);
  const classTraineeId = useSelector((state) => state.bulkEdit);
  const { classRequestId, classRosterId } = classTraineeId;
  const [allData, setAllData] = useState([]);
  const [equipmentSetup, setEquipmentSetup] = useState([]);
  const [order, setOrder] = useState("ASC");
  const [filterData, setFilterData] = useState([]);
  const initialRender = useRef(true);
  const [startTime, setStartTime] = useState("");
  const [stopTime, setStopTime] = useState("");
  const dispatch = useDispatch();
  const [handlevalue, setHandlevalue] = useState({
    PretrainingComment: "",
    EmployeeComment: "",
    AdditionalComments: "",
    EquipmentIssueComment: "",
  });
  const [totalActiveCount, setTotalActiveCount] = useState({
    total: 0,
    active: 0,
  });
  const [snack, setSnack] = useState({
    open: false,
    message: "",
    severity: "",
  });

  const sorting = (col) => {
    if (order === "ASC") {
      const sorted = [...employeeData].sort((a, b) =>
        a[col].toLowerCase() > b[col].toLowerCase() ? 1 : -1,
      );
      setEmployeeData(sorted);
      setOrder("DSC");
    }
    if (order === "DSC") {
      const sorted = [...employeeData].sort((a, b) =>
        a[col].toLowerCase() < b[col].toLowerCase() ? 1 : -1,
      );
      setEmployeeData(sorted);
      setOrder("ASC");
    }
  };

  useEffect(() => {
    let cancelled = false;

    const initialize = async () => {
      try {
        await fetchData();

        if (!cancelled) {
          applicationUsageLog(
            localStorage.getItem("User"),
            localStorage.getItem("EmailId"),
            "ASTT",
            "Employee Data",
          );
        }
      } catch (error) {
        if (!cancelled) {
          console.error("Failed to initialize:", error);
        }
      }
    };

    initialize();

    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    let cancelled = false;

    const refreshData = async () => {
      if (props.resetStatus === true) {
        try {
          await fetchData();
        } catch (error) {
          if (!cancelled) {
            console.error("Failed to refresh data:", error);
          }
        }
      }
    };

    refreshData();

    return () => {
      cancelled = true;
    };
  }, [props.resetStatus]);

  const fetchData = async () => {
    let data;
    setLoading(true);
    const response = await techEquipSolution();
    if (response.message === "Success") setTechSolData(response.data);
    else {
      setSnack({
        open: true,
        message: "Tech Equipment Solution dropdown could not be retrieved.",
        severity: "error",
      });
      setLoading(false);
    }
    let equipInfo = await getCurrentEquipmentSetup();
    if (equipInfo.message === "Success") setEquipmentSetup(equipInfo.data);
    else {
      setSnack({
        open: true,
        message: "Current Equipment Solution dropdown could not be retrieved.",
        severity: "error",
      });
      setLoading(false);
    }
    let traineeData = classTraineeId.traineeDetails.map((item) => {
      return {
        classTraineeId: item.classTraineeId,
      };
    });

    let obj = {
      classTraineeIdList: traineeData,
    };

    const rowdata = await getOverrideEmployeesData(obj);
    if (rowdata.message === "Success") {
      data = rowdata.data.employeeData.map((item) => {
        return {
          ...item,
        };
      });
      setEmployeeData(data);
      setFilterData(data);
      setAllData(data);
      dispatch(bulkEditStoreAction.setEmployeeData(data));
      dispatch(bulkEditStoreAction.setEmployeeAllData(data));
      setLoading(false);
    } else {
      setSnack({
        open: true,
        message: "Something went wrong while retrieving the data.",
        severity: "error",
      });
      setLoading(false);
    }

    if (props.resetStatus === true) {
      setEmployeeData(data);
      setFilterData(data);
      setAgentComments("");
      setTechSolStatus("");
      setCurrentEquipStatus("");
      setStartTime("");
      setStopTime("");
      setITPickupDropDownValue("");
      setEquipmentIssueDropDownValue("");
      setHandlevalue({
        PretrainingComment: "",
        EmployeeComment: "",
        AdditionalComments: "",
        EquipmentIssueComment: "",
      });
      props.onChange();
    }
    if (response.data) {
      filtering(props.filterStatus, data);
    }
  };

  const filtering = (filter, data) => {
    let filterData = [];

    if (filter === "ALL") {
      filterData = data;
    } else {
      filterData = data.filter(
        (item) => item.TraineeStatus === props.filterStatus,
      );
    }
    setEmployeeData(filterData);
    initialCheck(filterData);
    props.closeLoader();
  };

  const initialCheck = (data) => {
    let activeCount = getFilteredData(data, "TraineeStatus", "Active");
    setTotalActiveCount({
      total: data.length,
      active: activeCount.length,
    });
  };
  useEffect(() => {
    if (initialRender.current) {
      initialRender.current = false;
    } else {
      setLoading(true);

      const timeout = setTimeout(() => {
        filtering(props.filterStatus, filterData);
        setLoading(false);
      }, 1000);

      return () => {
        clearTimeout(timeout);
      };
    }
  }, [props.filterStatus]);

  const shouldUpdateKey = (item, index) => {
    return (
      (props.filterStatus === "ALL" &&
        item.OracleId === allData[index].OracleId) ||
      (props.filterStatus !== "ALL" &&
        item.TraineeStatus === props.filterStatus)
    );
  };

  const findInitialData = (oracleId) => {
    return allData.find((item) => item.OracleId === oracleId);
  };

  const handleAll = (eventValue, key) => {
    let data = [];
    let updatedEmployeeData = [];

    if (eventValue === "" || eventValue === " ") {
      data = filterData
        .map((item, i) => {
          if (shouldUpdateKey(item, i)) {
            return {
              ...item,
              [key]: allData[i][key],
            };
          }
          return null;
        })
        .filter(Boolean);

      updatedEmployeeData = employeeData.map((item) => {
        const initialData = findInitialData(item.OracleId);

        return {
          ...item,
          [key]: initialData[key],
        };
      });
    } else {
      data = filterData.map((item) => {
        if (
          props.filterStatus === "ALL" ||
          props.filterStatus === item.TraineeStatus
        )
          return {
            ...item,
            [key]: eventValue,
          };
        else return { ...item };
      });

      updatedEmployeeData = employeeData.map((item) => {
        return {
          ...item,
          [key]: eventValue,
        };
      });
    }
    setEmployeeData(updatedEmployeeData);
    setFilterData(data);
    dispatch(bulkEditStoreAction.setEmployeeData(updatedEmployeeData));
  };

  const snackReset = () => {
    setSnack({
      open: false,
      message: "",
      severity: "",
    });
  };
  const handleTextInput = (event, row, i) => {
    let data = filterData.map((item) => {
      if (
        item.OracleId === row.OracleId &&
        item.TraineeStatus === row.TraineeStatus
      ) {
        return {
          ...item,
          [event.target.name]: event.target.value,
        };
      } else {
        return item;
      }
    });

    let employee = employeeData.map((item) => {
      if (
        item.OracleId === row.OracleId &&
        item.TraineeStatus === row.TraineeStatus
      ) {
        return {
          ...item,
          [event.target.name]:
            event.target.value === "" ? null : event.target.value,
        };
      } else {
        return item;
      }
    });

    setEmployeeData(employee);
    setFilterData(data);
    dispatch(bulkEditStoreAction.setEmployeeData(employee));
  };

  const refreshTrackingStatus = async (type) => {
    setLoading(true);
    let traineeData = employeeData.map((item) => {
      return {
        classTraineeId: item.ClassTraineeId,
      };
    });

    let obj = {
      classTraineeIdList: traineeData,
    };

    let response = await getRefreshedTrackingStatus(obj);
    let clonedFilterData = JSON.parse(JSON.stringify(filterData));
    if (response.message === "Success") {
      if (response.data.equipmentShipmentDetails) {
        for (
          let i = 0;
          i < response.data.equipmentShipmentDetails.length;
          i++
        ) {
          if (
            clonedFilterData[i].OracleId ===
            response.data.equipmentShipmentDetails[i].oracleId
          )
            clonedFilterData[i].equipmentShipmentRecovery =
              response.data.equipmentShipmentDetails[
                i
              ].equipmentShipmentRecovery;
        }
      }

      setFilterData(clonedFilterData);

      filtering(props.filterStatus, clonedFilterData);
    } else {
      setSnack({
        open: true,
        message: "Unable to refresh the tracking status.",
        severity: "error",
      });
    }

    setLoading(false);
  };

  const handlechange = (e) => {
    setHandlevalue({
      ...handlevalue,
      [e.target.id]: e.target.value,
    });
  };

  const renderTextCell = (nameWithId, traineeStatus, isInactive) => (
    <Grid item xs={0.6} align="center">
      <p className={isInactive ? "text-decoration-line-bulk" : null}>
        {nameWithId}
      </p>
      {isInactive && <p className={classes.blueColor}>{traineeStatus}</p>}
    </Grid>
  );

  const handleIndividualText = (event, row, key) => {
    let data = filterData.map((item) => {
      if (
        item.OracleId === row.OracleId &&
        item.TraineeStatus === row.TraineeStatus
      ) {
        return {
          ...item,
          [key]: event.target.value,
        };
      } else {
        return item;
      }
    });
    let trainee = employeeData.map((item) => {
      if (
        item.OracleId === row.OracleId &&
        item.TraineeStatus === row.TraineeStatus
      ) {
        return {
          ...item,
          [key]: event.target.value === "" ? null : event.target.value,
        };
      } else {
        return item;
      }
    });
    setEmployeeData(trainee);
    setFilterData(data);
    dispatch(bulkEditStoreAction.setEmployeeData(trainee));
  };

  const navigateBack = () => {
    navigate(
      `/home/searchrosters?classRequestId=${classRequestId}&classRosterId=${classRosterId}`,
    );
  };

  const handleDateChange = (newValue, targetRow, key) => {
    const updatedEmployeeData = employeeData.map((row) =>
      row.OracleId === targetRow.OracleId ? { ...row, [key]: newValue } : row,
    );

    setEmployeeData(updatedEmployeeData);
    dispatch(bulkEditStoreAction.setEmployeeData(updatedEmployeeData));
  };

  const saveEmployeeData = async (e) => {
    setLoading(true);
    const obj = createData();
    const response = await saveBulkEditEmployeeData(obj);
    if (response.message === "Success") {
      setSnack({
        open: true,
        message: "Update completed successfully.",
        severity: "success",
      });
      setLoading(false);
      // Clear all header fields
      setAgentComments("");
      setTechSolStatus("");
      setCurrentEquipStatus("");
      setStartTime("");
      setStopTime("");
      setITPickupDropDownValue("");
      setEquipmentIssueDropDownValue("");
      setHandlevalue({
        PretrainingComment: "",
        EmployeeComment: "",
        AdditionalComments: "",
        EquipmentIssueComment: "",
      });
      fetchData();
    } else {
      setLoading(false);
      setSnack({
        open: true,
        message: "Failed to apply changes.",
        severity: "error",
      });
    }
  };

  const saveCloseHandler = async (e) => {
    setLoading(true);
    const obj = createData();
    const response = await saveBulkEditEmployeeData(obj);
    if (response.message === "Success") {
      const obj = {
        open: true,
        message: "Update completed successfully.",
        severity: "success",
      };

      dispatch(bulkEditStoreAction.setPreviousTabName(""));
      dispatch(SnackBarStoreAction.updateSnack(obj));
      navigateBack();
    } else {
      setSnack({
        open: true,
        message: "Failed to apply changes.",
        severity: "error",
      });
    }
  };

  const createData = () => {
    const obj = employeeData.map((item) => {
      return {
        classTraineeId: item.ClassTraineeId,
        agentComments: item.AgentComments,
        techEquipmentSolutionId:
          item.TechEquipmentSolutionId === null
            ? ""
            : item.TechEquipmentSolutionId.toString(),
        currentEquipmentSetupId: item.CurrentEquipmentSetupId
          ? item.CurrentEquipmentSetupId
          : null,
        startTime: item.StartTime,
        stopTime: item.StopTime,
        itAssetPickup: item.ItAssetPickup,
        equipmentIssue: item.EquipmentIssue,
        equipmentIssueComment: item.EquipmentIssueComment,
        hcTermTicket: item.HCTermTicket,
        pretrainingComment: item.PretrainingComment,
        additionalComments: item.AdditionalComments,
        modifiedBy: localStorage.getItem("User"),
      };
    });
    return obj;
  };

  return (
    <>
      {loading ? <BackdropComponent /> : null}
      <TableContainer
        className={classes.container}
        component={Paper}
        sx={{
          overflowX: "auto",
          overflowY: "auto",
        }}
      >
        <Table stickyHeader aria-label="sticky table" sx={{ minWidth: 2000 }}>
          <TableHead>
            <TableRow>
              <TableCell
                className={`${classes.tableHeaderCell} text-center align-center`}
                align="center"
                sx={{
                  minWidth: "320px !important",
                  maxWidth: 320,
                  position: "sticky",
                  left: 0,
                  top: "0 !important",
                  zIndex: "1100 !important",
                  boxShadow: "2px 0 5px -2px rgba(0,0,0,0.15)",
                  cursor: "pointer",
                  backgroundColor: "#e5e4e2 !important",
                }}
                onClick={() => sorting("Name")}
              >
                <span>{t("name")}</span>
                <Box sx={{ display: "inline-block" }}>
                  <ArrowUpwardIcon
                    sx={{
                      fontSize: 18,
                      color: order === "ASC" ? "#1976d2" : "#9e9e9e",
                      verticalAlign: "middle",
                    }}
                  />
                  <ArrowDownwardIcon
                    sx={{
                      fontSize: 18,
                      color: order === "DSC" ? "#1976d2" : "#9e9e9e",
                      verticalAlign: "middle",
                    }}
                  />
                </Box>
                <Typography
                  className={classes.blueColor}
                  sx={{ fontSize: "14px", margin: "0" }}
                >
                  Total: {totalActiveCount.total} | Active:{" "}
                  {totalActiveCount.active}
                </Typography>
              </TableCell>
              <TableCell
                className={`${classes.tableHeaderCell} text-center align-center`}
              >
                <Box
                  component="span"
                  sx={{
                    marginTop: 0,
                    display: "inline-block",
                    margin: "auto",
                    align: "center",
                    minHeight: 40,
                  }}
                >
                  {t("TechSol")}:
                </Box>{" "}
                <br />
                <FormControl className={classes.Select} size="small">
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    sx={{
                      "&:hover": {
                        "&& fieldset": {
                          border: "3px solid rgba(209, 217, 234, 1)",
                        },
                      },
                    }}
                    MenuProps={{
                      PaperProps: {
                        sx: {
                          "& .MuiMenuItem-root.Mui-selected": {
                            backgroundColor: "rgba(101, 128, 187, 1)",
                          },
                          "& .MuiMenuItem-root:hover": {
                            backgroundColor: "rgba(209, 217, 234, 1)",
                          },
                          "& .MuiMenuItem-root.Mui-selected:hover": {
                            backgroundColor: "rgba(209, 217, 234, 1)",
                          },
                        },
                      },
                    }}
                    value={techSolStatus}
                    onChange={(e) => {
                      setTechSolStatus(e.target.value);
                      handleAll(e.target.value, "TechEquipmentSolutionId");
                    }}
                  >
                    <MenuItem
                      key=" "
                      value=" "
                      sx={{ height: 25 }}
                      onClick={() => {
                        handleAll(" ", "TechEquipmentSolutionId");
                      }}
                    >
                      <b></b>
                    </MenuItem>
                    {techSolData
                      .filter((item) => item.TechEquipmentSolutionId !== 2)
                      .map((item) => (
                        <MenuItem
                          key={item.TechEquipmentSolutionId}
                          value={item.TechEquipmentSolutionId}
                        >
                          <b>{item.TechEquipmentSolution}</b>
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </TableCell>
              <TableCell
                className={`${classes.tableHeaderCell} text-center align-center`}
              >
                <Box sx={{ display: "inline-block", minHeight: 40 }}>
                  {t("CurrentEquipmentSetup")}
                </Box>
                <Box sx={{ display: "inline" }}>
                  <FormControl
                    className={classes.Select}
                    sx={{
                      marginTop: 10,
                      margin: "auto",
                      align: "center",
                    }}
                    size="small"
                  >
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={currentEquipStatus}
                      onChange={(e) => {
                        setCurrentEquipStatus(e.target.value);
                        handleAll(e.target.value, "CurrentEquipmentSetupId");
                      }}
                    >
                      <MenuItem
                        key=""
                        value=""
                        sx={{ height: 25 }}
                        onClick={(e) => {
                          setCurrentEquipStatus(e.target.value);
                          handleAll("", "CurrentEquipmentSetupId");
                        }}
                      ></MenuItem>
                      {equipmentSetup.map((item) => (
                        <MenuItem
                          value={item.TechEquipmentSetupId}
                          key={item.TechEquipmentSetupId}
                        >
                          <b>{item.TechEquipmentSetup}</b>
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>
              </TableCell>
              <TableCell
                className={`${classes.tableHeaderCell} text-center align-center`}
              >
                <Box sx={{ display: "inline" }}>{t("StartTime")}</Box>
                <Box display="flex" alignItems="center" gap={0.5}>
                  <TextField
                    size="small"
                    id="datetime-local"
                    type="time"
                    className={classes.timeInput}
                    value={startTime}
                    InputLabelProps={{
                      shrink: true,
                      inputFormat: "YYYY-MM-DD : HH:MM",
                    }}
                    onChange={(e) => {
                      setStartTime(e.target.value);
                      handleAll(
                        e.target.value === "" ? null : e.target.value,
                        "StartTime",
                      );
                    }}
                    fullWidth
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <Tooltip title="Cancel Start Time">
                            <IconButton
                              size="small"
                              onClick={() => {
                                setStartTime("");
                                handleAll("", "StartTime");
                              }}
                              sx={{ color: "red" }}
                            >
                              <NotInterestedIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Box>
              </TableCell>
              <TableCell
                className={`${classes.tableHeaderCell} text-center align-center`}
              >
                <Box sx={{ display: "inline" }}>{t("StopTime")}</Box>
                <Box display="flex" alignItems="center" gap={0.5}>
                  <TextField
                    size="small"
                    id="datetime-local"
                    type="time"
                    className={classes.timeInput}
                    value={stopTime}
                    InputLabelProps={{
                      shrink: true,
                      inputFormat: "YYYY-MM-DD : HH:MM",
                    }}
                    onChange={(e) => {
                      setStopTime(e.target.value);
                      handleAll(
                        e.target.value === "" ? null : e.target.value,
                        "StopTime",
                      );
                    }}
                    fullWidth
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <Tooltip title="Cancel Stop Time">
                            <IconButton
                              size="small"
                              onClick={() => {
                                setStopTime("");
                                handleAll("", "StopTime");
                              }}
                              sx={{ color: "red" }}
                            >
                              <NotInterestedIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Box>
              </TableCell>
              <TableCell
                className={`${classes.tableHeaderCell} text-center align-center`}
              >
                <Box sx={{ display: "inline" }}>{t("ITAssetPickup")}</Box>
                <Box sx={{ display: "inline" }}>
                  <br />
                  <FormControl className={classes.Select} size="small">
                    <InputLabel id="demo-simple-select-label"></InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={itPickupDropDownValue}
                      onChange={(e) => {
                        setITPickupDropDownValue(e.target.value);
                        handleAll(e.target.value, "ItAssetPickup");
                      }}
                      sx={{
                        "&:hover": {
                          "&& fieldset": {
                            border: "3px solid rgba(209, 217, 234, 1)",
                          },
                        },
                      }}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            "& .MuiMenuItem-root.Mui-selected": {
                              backgroundColor: "rgba(101, 128, 187, 1)",
                            },
                            "& .MuiMenuItem-root:hover": {
                              backgroundColor: "rgba(209, 217, 234, 1)",
                            },
                            "& .MuiMenuItem-root.Mui-selected:hover": {
                              backgroundColor: "rgba(209, 217, 234, 1)",
                            },
                          },
                        },
                      }}
                    >
                      <MenuItem
                        key=""
                        value=""
                        sx={{ height: 25 }}
                        onClick={(e) => {
                          setITPickupDropDownValue("");
                          handleAll("", "ItAssetPickup");
                        }}
                      ></MenuItem>
                      {ITPickupDropDown().map((item) => (
                        <MenuItem key={item} value={item}>
                          <b>{item}</b>
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>
              </TableCell>
              <TableCell
                className={`${classes.tableHeaderCell} text-center align-center`}
              >
                <Box sx={{ display: "inline" }}>{t("EquipmentIssue")}</Box>
                <Box sx={{ display: "inline" }}>
                  <br />
                  <FormControl className={classes.Select} size="small">
                    <InputLabel id="demo-simple-select-label"></InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={equipmentIssueDropDownValue}
                      onChange={(e) => {
                        setEquipmentIssueDropDownValue(e.target.value);
                        handleAll(e.target.value, "EquipmentIssue");
                      }}
                      sx={{
                        "&:hover": {
                          "&& fieldset": {
                            border: "3px solid rgba(209, 217, 234, 1)",
                          },
                        },
                      }}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            "& .MuiMenuItem-root.Mui-selected": {
                              backgroundColor: "rgba(101, 128, 187, 1)",
                            },
                            "& .MuiMenuItem-root:hover": {
                              backgroundColor: "rgba(209, 217, 234, 1)",
                            },
                            "& .MuiMenuItem-root.Mui-selected:hover": {
                              backgroundColor: "rgba(209, 217, 234, 1)",
                            },
                          },
                        },
                      }}
                    >
                      <MenuItem
                        key=""
                        value=""
                        sx={{ height: 25 }}
                        onClick={(e) => {
                          setEquipmentIssueDropDownValue("");
                          handleAll("", "EquipmentIssue");
                        }}
                      ></MenuItem>
                      {EquipmentIssueDropDown().map((item) => (
                        <MenuItem key={item} value={item}>
                          <b>{item}</b>
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>
              </TableCell>
              <TableCell
                className={`${classes.tableHeaderCell} text-center align-center`}
              >
                <div>{t("EquipmentIssueComment")}</div>
                <div>
                  <textarea
                    value={handlevalue.EquipmentIssueComment}
                    name="EquipmentIssueComment"
                    id="EquipmentIssueComment"
                    className={classes.inputContainer}
                    type="text"
                    placeholder="Max 1000 characters allowed"
                    maxLength={1000}
                    onChange={(e) => {
                      handlechange(e);
                      handleAll(e.target.value, "EquipmentIssueComment");
                    }}
                  ></textarea>
                </div>
              </TableCell>
              <TableCell
                className={`${classes.tableHeaderCell} text-center align-center`}
                sx={{
                  minWidth: "55vh",
                }}
              >
                <Grid container spacing={2}>
                  <Grid item xs={12} sx={{ marginTop: 2 }}>
                    <span>{t("EquipmentShipment/Recovery")}</span>
                  </Grid>
                </Grid>
                <Grid container spacing={2} sx={{ paddingTop: "4px" }}>
                  <Grid item xs={5}>
                    <CustomUploadhButton
                      onClick={() =>
                        window.open(
                          "https://teletechinc.sharepoint.com/sites/GS2013_SP2007_IT/CorporateDesktopOperations/RemoteRegionalSupportModel/Lists/ASTTImportStatusShipmentInfo/AllItems.aspx",
                          "_blank",
                        )
                      }
                    >
                      <LaunchOutlinedIcon style={{ marginRight: 8 }} />
                      {t("ShipmentReportUploadHistory")}
                    </CustomUploadhButton>
                  </Grid>
                  <Grid item xs={5}>
                    <CustomRefreshButton
                      sx={{}}
                      onClick={() => refreshTrackingStatus()}
                    >
                      <CachedOutlinedIcon style={{ marginRight: 8 }} />
                      {t("RefreshTrackingStatus")}
                    </CustomRefreshButton>
                  </Grid>
                  <Grid item xs={2}></Grid>
                </Grid>
              </TableCell>
              <TableCell
                className={`${classes.tableHeaderCell} text-center align-center`}
              >
                <div>{t("IDMTicket")}</div>
              </TableCell>
              <TableCell
                className={`${classes.tableHeaderCell} text-center align-center`}
              >
                <div>{t("HCTermTicket")}</div>
              </TableCell>
              <TableCell
                className={`${classes.tableHeaderCell} text-center align-center`}
              >
                <div>{t("PreTrainingComments")}</div>

                <div>
                  <textarea
                    value={handlevalue.PretrainingComment}
                    name="wave"
                    id="PretrainingComment"
                    className={classes.inputContainer}
                    type="text"
                    placeholder="Max 1000 characters allowed"
                    maxLength={1000}
                    onChange={(e) => {
                      handlechange(e);
                      handleAll(e.target.value, "PretrainingComment");
                    }}
                  ></textarea>
                </div>
                <p className={classes.redColor}>{t("note1")}</p>
              </TableCell>
              <TableCell
                className={`${classes.tableHeaderCell} text-center align-center`}
              >
                <div>{t("AttendanceComments")}</div>
                <div>
                  <textarea
                    value={handlevalue.AdditionalComments}
                    name="wave"
                    id="AdditionalComments"
                    className={classes.inputContainer}
                    type="text"
                    placeholder="Max 1000 characters allowed"
                    maxLength={1000}
                    onChange={(e) => {
                      handlechange(e);
                      handleAll(e.target.value, "AdditionalComments");
                    }}
                  ></textarea>
                </div>
                <p className={classes.redColor}>{t("note2")}</p>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {/* Table Rows */}
            {employeeData.length > 0 &&
              employeeData.map((row, i) => {
                const rowKey = `${row.OracleId}-${i}`;
                return (
                  <TableRow key={rowKey}>
                    <TableCell
                      align="center"
                      sx={{
                        position: "sticky",
                        left: 0,
                        backgroundColor: "#fff",
                        zIndex: 1,
                        boxShadow: "2px 0 5px -2px rgba(0,0,0,0.15)",
                      }}
                    >
                      {/* Individual Row Cells */}
                      <Grid
                        container
                        direction="row"
                        justifyContent="center"
                        columns={1}
                        alignItems="center"
                        spacing={0}
                      >
                        {renderTextCell(
                          `${row.Name} (${row.OracleId})`,
                          row.TraineeStatus,
                          row.TraineeStatus !== "Active",
                        )}
                        {row.TTECRegistrationStatus ? (
                          <Grid item xs={0.1}>
                            <Tooltip title="TTEConnect: Registered">
                              <PowerSharpIcon
                                placeholder="TTEConnect: Registered"
                                sx={{ color: "#69DE00" }}
                              />
                            </Tooltip>
                          </Grid>
                        ) : (
                          <Grid item xs={0.1}></Grid>
                        )}
                        <LastUpdateTooltip
                          AgentCommentsModifiedDate={
                            row.AgentCommentsModifiedDate
                          }
                          AgentCommentsModifiedBy={row.AgentCommentsModifiedBy}
                        >
                          <textarea
                            className={classes.agentCommentInputContainer}
                            value={row.AgentComments ? row.AgentComments : ""}
                            maxLength={4000}
                            placeholder="Max 4000 characters allowed"
                            onChange={(e) =>
                              handleIndividualText(e, row, "AgentComments")
                            }
                            style={{ width: "100%", minWidth: "350px" }}
                          ></textarea>
                        </LastUpdateTooltip>
                      </Grid>
                    </TableCell>
                    {/* Other Cells */}
                    <TableCell align="center" sx={{ padding: 0.75 }}>
                      <FormControl className={classes.Select} size="small">
                        <InputLabel id="demo-simple-select-label"></InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          name="TechEquipmentSolutionId"
                          value={row.TechEquipmentSolutionId}
                          onChange={(e) => handleTextInput(e, row, i)}
                        >
                          {techSolData
                            .filter(
                              (item) =>
                                row.TechEquipmentSolutionId === 2 ||
                                item.TechEquipmentSolutionId !== 2,
                            )
                            .map((item) => (
                              <MenuItem
                                key={item.TechEquipmentSolutionId}
                                value={item.TechEquipmentSolutionId}
                              >
                                <b>{item.TechEquipmentSolution}</b>
                              </MenuItem>
                            ))}
                        </Select>
                      </FormControl>
                    </TableCell>
                    <TableCell align="center">
                      <FormControl className={classes.Select} size="small">
                        <InputLabel id="demo-simple-select-label"></InputLabel>
                        <Select
                          name="CurrentEquipmentSetupId"
                          value={
                            row.CurrentEquipmentSetupId !== null
                              ? row.CurrentEquipmentSetupId
                              : ""
                          }
                          onChange={(e) => handleTextInput(e, row, i)}
                          sx={{
                            "&:hover": {
                              "&& fieldset": {
                                border: "3px solid rgba(209, 217, 234, 1)",
                              },
                            },
                          }}
                          MenuProps={{
                            PaperProps: {
                              sx: {
                                "& .MuiMenuItem-root.Mui-selected": {
                                  backgroundColor: "rgba(101, 128, 187, 1)",
                                },
                                "& .MuiMenuItem-root:hover": {
                                  backgroundColor: "rgba(209, 217, 234, 1)",
                                },
                                "& .MuiMenuItem-root.Mui-selected:hover": {
                                  backgroundColor: "rgba(209, 217, 234, 1)",
                                },
                              },
                            },
                          }}
                        >
                          <MenuItem
                            key={row.OracleId}
                            value=""
                            sx={{ height: 25 }}
                          ></MenuItem>
                          {equipmentSetup.map((item) => (
                            <MenuItem
                              value={item.TechEquipmentSetupId}
                              key={item.TechEquipmentId}
                            >
                              <b>{item.TechEquipmentSetup}</b>
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </TableCell>

                    <TableCell align="center" sx={{ pl: 2 }}>
                      <TextField
                        name="startHour"
                        size="small"
                        id="datetime-local"
                        type="time"
                        value={row.StartTime || ""}
                        className={classes.timeInput}
                        InputLabelProps={{
                          shrink: true,
                          inputFormat: "YYYY-MM-DD : HH:MM",
                        }}
                        onChange={(e) =>
                          handleDateChange(
                            e.target.value === "" ? null : e.target.value,
                            row,
                            "StartTime",
                          )
                        }
                        fullWidth
                      />
                    </TableCell>
                    <TableCell align="center" sx={{ pl: 2 }}>
                      <TextField
                        name="stopTime"
                        size="small"
                        id="datetime-local"
                        type="time"
                        className={classes.timeInput}
                        value={row.StopTime || ""}
                        InputLabelProps={{
                          shrink: true,
                          inputFormat: "YYYY-MM-DD : HH:MM",
                        }}
                        onChange={(e) =>
                          handleDateChange(
                            e.target.value === "" ? null : e.target.value,
                            row,
                            "StopTime",
                          )
                        }
                        fullWidth
                      />
                    </TableCell>
                    <TableCell align="center">
                      <FormControl className={classes.Select} size="small">
                        <InputLabel id="demo-simple-select-label"></InputLabel>
                        <Select
                          name="ItAssetPickup"
                          value={row.ItAssetPickup}
                          onChange={(e) => handleTextInput(e, row, i)}
                          sx={{
                            "&:hover": {
                              "&& fieldset": {
                                border: "3px solid rgba(209, 217, 234, 1)",
                              },
                            },
                          }}
                          MenuProps={{
                            PaperProps: {
                              sx: {
                                "& .MuiMenuItem-root.Mui-selected": {
                                  backgroundColor: "rgba(101, 128, 187, 1)",
                                },
                                "& .MuiMenuItem-root:hover": {
                                  backgroundColor: "rgba(209, 217, 234, 1)",
                                },
                                "& .MuiMenuItem-root.Mui-selected:hover": {
                                  backgroundColor: "rgba(209, 217, 234, 1)",
                                },
                              },
                            },
                          }}
                        >
                          <MenuItem
                            key=""
                            value=""
                            sx={{ height: 25 }}
                          ></MenuItem>
                          {ITPickupDropDown().map((item) => (
                            <MenuItem key={item} value={item}>
                              <b>{item}</b>
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                      <br />
                      <span>{row.ItAssetPickup}</span>
                    </TableCell>
                    <TableCell align="center">
                      <FormControl className={classes.Select} size="small">
                        <InputLabel id="demo-simple-select-label"></InputLabel>
                        <Select
                          name="EquipmentIssue"
                          value={row.EquipmentIssue}
                          onChange={(e) => handleTextInput(e, row, i)}
                          sx={{
                            "&:hover": {
                              "&& fieldset": {
                                border: "3px solid rgba(209, 217, 234, 1)",
                              },
                            },
                          }}
                          MenuProps={{
                            PaperProps: {
                              sx: {
                                "& .MuiMenuItem-root.Mui-selected": {
                                  backgroundColor: "rgba(101, 128, 187, 1)",
                                },
                                "& .MuiMenuItem-root:hover": {
                                  backgroundColor: "rgba(209, 217, 234, 1)",
                                },
                                "& .MuiMenuItem-root.Mui-selected:hover": {
                                  backgroundColor: "rgba(209, 217, 234, 1)",
                                },
                              },
                            },
                          }}
                        >
                          <MenuItem
                            key=""
                            value=""
                            sx={{ height: 25 }}
                          ></MenuItem>
                          {EquipmentIssueDropDown().map((item) => (
                            <MenuItem key={item} value={item}>
                              <b>{item}</b>
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                      <br />
                      <span>{row.EquipmentIssue}</span>
                    </TableCell>
                    <TableCell align="center">
                      <textarea
                        value={
                          row.EquipmentIssueComment === null
                            ? ""
                            : row.EquipmentIssueComment
                        }
                        name={row.EquipmentIssueComment}
                        maxLength={1000}
                        className={classes.inputContainer}
                        onChange={(e) =>
                          handleIndividualText(e, row, "EquipmentIssueComment")
                        }
                        placeholder="Max 1000 characters allowed"
                      ></textarea>
                    </TableCell>
                    <TableCell align="center">
                      <div
                        className={classes.rowheight}
                        dangerouslySetInnerHTML={{
                          __html: row.EquipmentShipmentRecovery,
                        }}
                      ></div>
                    </TableCell>
                    <TableCell
                      align="center"
                      className={classes.inputContainerSmall}
                    >
                      {row.IDMTicketNumber === null ? "" : row.IDMTicketNumber}
                    </TableCell>
                    <TableCell align="center">
                      <input
                        value={
                          row.HCTermTicket === null ? "" : row.HCTermTicket
                        }
                        name={row.HCTermTicket}
                        className={classes.inputContainerSmall}
                        type="text"
                        maxLength={15}
                        onChange={(e) =>
                          handleIndividualText(e, row, "HCTermTicket")
                        }
                      ></input>
                    </TableCell>
                    <TableCell align="center">
                      <textarea
                        value={
                          row.PretrainingComment === null
                            ? ""
                            : row.PretrainingComment
                        }
                        name={row.PretrainingComment}
                        maxLength={1000}
                        className={classes.inputContainer}
                        onChange={(e) =>
                          handleIndividualText(e, row, "PretrainingComment")
                        }
                        placeholder="Max 1000 characters allowed"
                      ></textarea>
                    </TableCell>
                    <TableCell align="center">
                      <textarea
                        value={
                          row.AdditionalComments === null
                            ? ""
                            : row.AdditionalComments
                        }
                        name={row.AdditionalComments}
                        maxLength={1000}
                        className={classes.inputContainer}
                        onChange={(e) =>
                          handleIndividualText(e, row, "AdditionalComments")
                        }
                        placeholder="Max 1000 characters allowed"
                      ></textarea>
                    </TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
      {/* SnackBar Component */}
      <SnackBar snack={snack} snackReset={snackReset}></SnackBar>
      {/* Buttons */}
      <Grid
        item
        xs={12}
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          paddingTop: 2,
          gap: 1,
        }}
      >
        <CustomOutlinedButton variant="outlined" onClick={navigateBack}>
          {t("CANCEL")}
        </CustomOutlinedButton>
        <CustomButton onClick={(e) => saveEmployeeData(e)}>
          {t("SAVE")}
        </CustomButton>
        <CustomButton onClick={(e) => saveCloseHandler(e)}>
          {t("SAVE+CLOSE")}
        </CustomButton>
      </Grid>
    </>
  );
};

EmployeeData.prototype = {
  filterStatus: PropTypes.string,
  closeLoader: PropTypes.func,
  resetStatus: PropTypes.bool,
  onChange: PropTypes.func,
};

export default EmployeeData;
